import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../text/variants';
import { TooltipVariantType } from '../tooltip/variants';
import { VirtualKeyboardVariantType } from './../virtualKeyboard/variants';
export const variantStatesCommonStyles = (FOUNDATIONS, FONT) => ({
    legendTooltipContainer: {
        display: 'flex',
        align_items: 'center',
        justify_content: 'space-between',
        gap: FOUNDATIONS.spacing_150,
        margin_bottom: FOUNDATIONS.spacing_150,
    },
    legend: {
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_neutral_font_50,
    },
    tooltipIcon: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
        color: FOUNDATIONS.color_accent_default_secondary_icon_100,
    },
    inputContainer: {
        width: '100%',
        display: 'flex',
        flex_direction: 'row',
        align_items: 'center',
        justify_content: 'space-between',
        cursor: 'pointer',
        border_radius: FOUNDATIONS.radius_comp_forms_input_radiussize,
        gap: FOUNDATIONS.spacing_200,
        padding: `${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_200}`,
        border_style: 'solid',
        background_color: FOUNDATIONS.color_comp_forms_input_bg,
        border_width: FOUNDATIONS.border_50,
        border_color: FOUNDATIONS.color_neutral_border_150,
    },
    digitsContainer: {
        width: '100%',
        display: 'flex',
        flex_direction: 'row',
        justify_content: 'space-between',
        align_items: 'center',
        gap: FOUNDATIONS.spacing_200,
    },
    inputSeparator: {
        display: 'none',
    },
    actionIconsContainer: {
        display: 'flex',
        flex_direction: 'row',
        align_items: 'center',
        gap: FOUNDATIONS.spacing_200,
    },
    passwordIcon: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
        color: FOUNDATIONS.color_accent_default_secondary_icon_100,
    },
    keyboardIcon: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
        color: FOUNDATIONS.color_accent_default_secondary_icon_100,
    },
    inputPositionLabelsContainer: {
        display: 'flex',
        flex_direction: 'column',
        gap: FOUNDATIONS.spacing_150,
        [DeviceBreakpointsType.TABLET]: {
            flex_direction: 'column-reverse',
        },
        [DeviceBreakpointsType.MOBILE]: {
            flex_direction: 'column-reverse',
        },
    },
    positionLabelsContainer: {
        width: '100%',
        display: 'flex',
        flex_direction: 'row',
        align_items: 'center',
        justify_content: 'space-between',
        gap: FOUNDATIONS.spacing_200,
        padding_left: FOUNDATIONS.spacing_200,
        padding_right: FOUNDATIONS.spacing_200,
    },
    positionLabelContainer: {
        display: 'flex',
        justify_content: 'center',
        align_content: 'center',
        width: '100%',
    },
    positionLabel: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_neutral_font_50,
    },
    errorContainer: {
        width: '100%',
        display: 'flex',
        flex_direction: 'row',
        margin_top: FOUNDATIONS.spacing_150,
        gap: FOUNDATIONS.spacing_100,
    },
    errorIcon: {
        width: FOUNDATIONS.size_250,
        height: FOUNDATIONS.size_250,
    },
    errorMessage: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_feedback_error_font_50,
    },
    helpTextContainer: {
        margin_top: FOUNDATIONS.spacing_150,
    },
    helpText: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_comp_forms_input_secondaryfont,
    },
    virtualKeyboardContainer: {
        margin_top: FOUNDATIONS.spacing_200,
    },
    tooltip: {
        variant: TooltipVariantType.REGULAR,
    },
    virtualKeyboardVariant: VirtualKeyboardVariantType.REGULAR,
});
export const variantStateInputDigitPasswordDigitCommonStyles = (FOUNDATIONS, FONT) => ({
    digitContainer: {
        position: 'relative',
        width: '100%',
        height: '1.75rem',
    },
    digitShape: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        pointer_events: 'none',
        showDigit: true,
    },
    digitInput: {
        color: 'transparent',
    },
    digitInputContainer: {
        width: '100%',
        height: '100%',
        border_bottom_style: 'solid',
        border_width: FOUNDATIONS.border_50,
        border_color: FOUNDATIONS.color_neutral_border_150,
    },
});
//# sourceMappingURL=commonStyles.js.map